import { useLayoutEffect, useRef } from 'preact/hooks'

import { CookieConsentTranslator } from '#src/assets/lib/i18n.ts'
import { bodyTextStyle, linkStyle } from '#src/assets/ui/shared/styles.ts'
import { SiteConfig } from '~/src/models/site-configs/siteConfigs.ts'

export function CookieConsentDescription({
  t,
  siteConfig,
}: {
  t: CookieConsentTranslator
  siteConfig: SiteConfig
}) {
  const containerRef = useRef<HTMLDivElement>(null)
  const html = t('consentModalDescription', {
    policyUrl: siteConfig.cookiePolicyUrl,
    coachName: siteConfig.coachName,
  })

  useLayoutEffect(() => {
    const links = containerRef.current?.querySelectorAll('a')
    if (!links) {
      return
    }

    const cleanups: Array<() => void> = []

    links.forEach(link => {
      Object.assign(link.style, linkStyle)

      const handleMouseEnter = () => {
        link.style.textDecoration = 'underline'
      }
      const handleMouseLeave = () => {
        link.style.textDecoration = 'none'
      }

      link.addEventListener('mouseenter', handleMouseEnter)
      link.addEventListener('mouseleave', handleMouseLeave)
      cleanups.push(() => {
        link.removeEventListener('mouseenter', handleMouseEnter)
        link.removeEventListener('mouseleave', handleMouseLeave)
      })
    })

    return () => {
      cleanups.forEach(cleanup => cleanup())
    }
  }, [html])

  return (
    <div
      ref={containerRef}
      style={bodyTextStyle}
      dangerouslySetInnerHTML={{ __html: html }}
    />
  )
}
